import css from './Heading.module.css'

export default function Heading({ level = 'h2', slug, children, ...rest }) {
    const TagName = level.toLowerCase()
    return (
        <TagName className={css.heading} {...rest}>
            {children}
            {slug && <div className={css.anchor} id={slug} />}
        </TagName>
    )
}
